/**
 * Event Transport Layer for the Side Navigation.
 */
import Vue from 'vue';

const NavBus = new Vue();

export default NavBus;


// WEBPACK FOOTER //
// ./src/buses/nav.js